<template>
    <div class="del-wrap">
        <slot>
        </slot>
        <div v-if="showClose"  class="icon-close" @click.stop="handleClose">
            <i class="el-icon-close"></i>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        showClose:{ //是否显示关闭按钮
            type:Boolean,
            default:true,
        },
    },

    data(){
        return{
            
        }
    },

    methods:{
        handleClose(){
            this.$emit('close');
        }
    },

}
</script>

<style scoped lang="scss">
.del-wrap {
    position: relative;
    &:hover > .icon-close {
        display: flex;
    }
    .icon-close {
        display: none;
        position: absolute;
        top: -8px;
        right: -8px;
        width: 16px;
        height: 16px;
        background-color: rgba(0, 0, 0, 0.3);
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        color: #fff;
        cursor: pointer;
    }
}
</style>